export default __webpack_public_path__ + "static/media/Litros.ac41ddb5.jpg";